import { render, staticRenderFns } from "./ChoiceEvaluateModel.vue?vue&type=template&id=686ffada&scoped=true"
import script from "./ChoiceEvaluateModel.vue?vue&type=script&lang=js"
export * from "./ChoiceEvaluateModel.vue?vue&type=script&lang=js"
import style0 from "./ChoiceEvaluateModel.vue?vue&type=style&index=0&id=686ffada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686ffada",
  null
  
)

export default component.exports